<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
            <el-form-item label="租户名称:" prop="tenantName">
              <el-input  placeholder="" v-model="searchFrom.tenantName"></el-input>
            </el-form-item>
            <el-form-item label="业务单号:" prop="businessNo">
              <el-input  placeholder="" v-model="searchFrom.businessNo"></el-input>
            </el-form-item>
            <el-form-item label="上报状态:" prop="reportStatus">
                <el-select  v-model="searchFrom.reportStatus"   placeholder="请选择">
                  <el-option label="未上报" value="1"></el-option>
                  <el-option label="已上报" value="2"></el-option>
                  <el-option label="上报失败" value="3"></el-option>
                  <el-option label="不上报" value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="上报时间:" prop="reportTime">
                <el-date-picker
                  v-model="searchFrom.reportTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
            </el-form-item>
            </div>
          </div>
            <div class="searchBtnBox">
              <el-form-item>
                <el-button type="primary" v-if="btnFlg[0]"  @click="searchFn">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" v-if="btnFlg[1]"  @click="exportFn"  :disabled="isDisable" >导出</el-button>
              </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作"  width="80" >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="reportClick(scope.row)" v-if="btnFlg[2]" >上报</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="tenantName"  min-width="260" :formatter="emptyFn" label="租户名称"></el-table-column>
        <el-table-column prop="businessNo"  min-width="200" :formatter="emptyFn" label="业务单号"></el-table-column>
        <el-table-column prop="businessType"  min-width="120"  label="业务单类型">
          <template scope="scope">
            <div>
              {{[ "订单", "运单" ][scope.row.businessType-1]}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="freight"  width="150" :formatter="emptyFn" label="运费"></el-table-column>
        <el-table-column prop="reportStatus"  min-width="120" label="上报状态">
          <template scope="scope">
            <div>
              {{[ "未上报", "已上报", "上报失败", "不上报" ][scope.row.reportStatus-1]}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="reportTime"  min-width="180" :formatter="dateTimeFormat" label="上报时间"></el-table-column>
        <el-table-column prop="remark"  min-width="170" :formatter="emptyFn" label="备注"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { sBusinessReportList, updateReportStatus } from '@/api/consignment'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  data () {
    return {
      isDisable: false,
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        reportType: 2,
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      goodTypes: [],
      btnFlg: [],
      btnIdArr: ['00JM110100', '00JM110200', '00JM110300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/paymenWithholding/waybillReport')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    exportFn () {
      let form = { ...this.searchFrom }
      exportExcel(
        this.global.orderName + '/sBusinessReport/exportList',
        form,
        '运单上报列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 点击上报
    reportClick (row) {
      this.$confirm('运单上报状态将修改为未上报，是否重新上报运单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        updateReportStatus({
          id: row.id
        }).then(() => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sBusinessReportList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        reportType: 2
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
</style>
